import { Chip, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

import { DeviationArticleStatus } from "../../../entities/DeviationArticleStatus";

const useStyles = makeStyles({
	conflictCell: {
		backgroundColor: "#ffcdd2", // red-ish
		cursor: "pointer",
		fontWeight: "bold",
	},
	addChip: { backgroundColor: "#c8e6c9" /* green-ish */ },
	conflictChip: { backgroundColor: "#ffcdd2" /* red-ish */ },
});

const getStatusInfo = (item, classes) => {
	switch (item.article_status) {
		case DeviationArticleStatus.ADD:
			return <Chip size="small" label="Will be added" className={classes.addChip} />;
		case DeviationArticleStatus.RESOLVED:
			return <Chip size="small" label="Resolved" className={classes.addChip} />;
		case DeviationArticleStatus.CONFLICT:
			if (item.resolution) {
				return (
					<Chip
						size="small"
						label={`Resolved: Use ${item.resolution.article_units} units`}
						color="primary"
					/>
				);
			}
			return <Chip size="small" label="Units conflict!" className={classes.conflictChip} />;
		case DeviationArticleStatus.IGNORE:
			return <Chip size="small" label="No changes" />;
		default:
			return null;
	}
};

export const SyncTable = ({ articles, onResolveClick }) => {
	const classes = useStyles();

	return (
		<Paper>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell>Article Code</TableCell>
						<TableCell>Description</TableCell>
						<TableCell>Units</TableCell>
						<TableCell>Resolved Units</TableCell>
						<TableCell>Status</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{articles.map((item) => (
						<TableRow key={item.article_code}>
							<TableCell>{item.article_code}</TableCell>
							<TableCell>{item.service_description}</TableCell>
							<TableCell
								className={
									item.article_status === DeviationArticleStatus.CONFLICT && !item.resolution
										? classes.conflictCell
										: ""
								}
								onClick={() =>
									item.article_status === DeviationArticleStatus.CONFLICT && onResolveClick(item)
								}
							>
								{item.article_units}
							</TableCell>
							<TableCell>{item.resolved_units}</TableCell>
							<TableCell>{getStatusInfo(item, classes)}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</Paper>
	);
};
